/**
 *
 * Asynchronously loads the component for Buildings Page
 *
 */

import { lazyLoad } from 'utils/loadable';

export const BuildingsPage = lazyLoad(
  () => import('./index'),
  module => module.BuildingsPage,
);
